import { useApproveImagesPost } from "../api";
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog.tsx";
import { Button } from "@/shared/ui/button.tsx";
import { Badge } from "@/shared/ui/badge.tsx";
import { TableCell, TableRow } from "@/shared/ui/table.tsx";
import { Check, Copy, Download, Loader2 } from "lucide-react";
import UploadFormDialog from "./UploadFormDialog";
import { ImageBody } from "../types";

const ImageRow = ({ image }: { image: ImageBody }) => {

  const { approveImage, status } = useApproveImagesPost();

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = image.image_url;
    link.download = image.image_url.split('/').pop() || 'image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <TableRow>
      <TableCell>
        <Dialog>
          <DialogTrigger>
            <div className="relative size-48 rounded-md overflow-hidden border">
              <img
                src={image.image_url || "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9d2FhIMaW1N59xiqsVbDapcKzCBJueQwGhflZ"}
                alt={image.catalogue_item}
                className="object-cover"
              />
            </div>
          </DialogTrigger>
          <DialogContent className="max-w-2xl bg-black text-purple-500 font-semibold border-none outline-black p-0">
            <div className="absolute bottom-2 right-2 flex items-center gap-2">
              <Button size="icon" title="Download Image" onClick={handleDownload}>
                <Download />
              </Button>
            </div>
            <img src={image.image_url} className="w-full h-auto rounded-lg" alt="Full View" />
          </DialogContent>
        </Dialog>
      </TableCell>
      <TableCell className="font-medium">{image.catalogue_item}</TableCell>
      <TableCell className="font-poppins tracking-wide leading-relaxed relative">
        <Button
          variant="outline"
          className="absolute top-1 right-1 h-6 w-fit px-3 text-xs"
          onClick={() => {
            navigator.clipboard.writeText(image.prompt)
          }}
        >
          <Copy className="w-4 h-4 scale-75" />
          Copy
        </Button>
        {image.prompt.slice(0, 300)}...
      </TableCell>
      <TableCell>
        <Badge variant="secondary">{image.post_id.length}</Badge>
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          <Button
            size="sm"
            disabled={status === "pending"}
            onClick={() => approveImage({ postIds: image.post_id, image_id: image.image_id })}
          >
            {status === "pending" ? (
              <>
                <Loader2 className="animate-spin size-4" />
                Approving...
              </>
            ) : (
              <>
                <Check className="w-4 h-4 mr-1" />
                Approve
              </>
            )}
          </Button>
          <UploadFormDialog postIds={image.post_id} />
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ImageRow;
